import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getDefaultPeriod, PeriodValue } from "@/shared/ui/period-picker"
import { RestaurantMenuAnalyticsDrilldown, RestaurantMenuAnalyticsFiltersState } from "./types"

const createInitialState = (): RestaurantMenuAnalyticsFiltersState => ({
    period: getDefaultPeriod(),
    menuIds: [],
    statuses: [],
    tableId: "",
    page: 1,
})

const restaurantMenuAnalyticsSlice = createSlice({
    name: "restaurantMenuAnalytics",
    initialState: createInitialState(),
    reducers: {
        setRestaurantMenuAnalyticsPeriod(state, action: PayloadAction<PeriodValue>) {
            state.period = action.payload
            state.page = 1
        },
        setRestaurantMenuAnalyticsMenuIds(state, action: PayloadAction<string[]>) {
            state.menuIds = action.payload
            state.page = 1
        },
        setRestaurantMenuAnalyticsStatuses(state, action: PayloadAction<string[]>) {
            state.statuses = action.payload
            state.page = 1
        },
        setRestaurantMenuAnalyticsTableId(state, action: PayloadAction<string>) {
            state.tableId = action.payload
            state.page = 1
        },
        setRestaurantMenuAnalyticsPage(state, action: PayloadAction<number>) {
            state.page = action.payload
        },
        applyRestaurantMenuAnalyticsDrilldown(state, action: PayloadAction<RestaurantMenuAnalyticsDrilldown>) {
            state.period = action.payload.period
            state.menuIds = action.payload.menuIds
            state.statuses = action.payload.statuses
            state.tableId = action.payload.tableId ?? ""
            state.page = 1
        },
        resetRestaurantMenuAnalyticsFilters() {
            return createInitialState()
        },
    },
})

export const {
    applyRestaurantMenuAnalyticsDrilldown,
    resetRestaurantMenuAnalyticsFilters,
    setRestaurantMenuAnalyticsMenuIds,
    setRestaurantMenuAnalyticsPage,
    setRestaurantMenuAnalyticsPeriod,
    setRestaurantMenuAnalyticsStatuses,
    setRestaurantMenuAnalyticsTableId,
} = restaurantMenuAnalyticsSlice.actions

export default restaurantMenuAnalyticsSlice.reducer
